import { render, staticRenderFns } from "./ReadTS.vue?vue&type=template&id=ec82c68c&scoped=true&"
import script from "./ReadTS.vue?vue&type=script&lang=js&"
export * from "./ReadTS.vue?vue&type=script&lang=js&"
import style0 from "./ReadTS.vue?vue&type=style&index=0&id=ec82c68c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec82c68c",
  null
  
)

export default component.exports